import APIRequestState from '../_util/api-request';

class UpdateUserProfileState extends APIRequestState {
  get method() { return 'PUT'; }
  get url() { return '/me'; }
}

export default UpdateUserProfileState;



// WEBPACK FOOTER //
// ./spa/state/user/update-profile.jsx